import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function RSSIcon({
	width,
	height,
	active = false,
	'aria-label': ariaLabel = 'RSS',
	style,
	customIconColor,
	...rest
}: IconRenderProps): ReactElement {
	const bg = customIconColor?.bgColor ?? '#FFFFFF';
	const g = customIconColor?.glyphColor ?? (active ? '#1E1E1E' : 'rgba(30,30,30,.48)');

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width ?? '100%'}
			height={height ?? '100%'}
			viewBox="0 0 40 40"
			fill="none"
			role="img"
			aria-label={ariaLabel}
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<title>RSS</title>

			<rect width="40" height="40" rx="8" fill={bg} />

			<g transform="translate(-4 -6) scale(1.80)">
				{/* dot */}
				<circle cx="9.82134" cy="19.1768" r="1.82134" fill={g} />

				{/* waves */}
				<path
					d="M8 8V10.3644C13.8734 10.3644 18.6356 15.1266 18.6356 21H21C21 13.8233 15.1767 8 8 8ZM8 12.7288V15.0932C11.2584 15.0932 13.9068 17.7416 13.9068 21H16.2712C16.2712 16.4299 12.5701 12.7288 8 12.7288Z"
					fill={g}
				/>
			</g>
		</svg>
	);
}
